import { render } from "./PayModeManage.vue?vue&type=template&id=b572ccd6"
import script from "./PayModeManage.vue?vue&type=script&lang=js"
export * from "./PayModeManage.vue?vue&type=script&lang=js"

import "./PayModeManage.vue?vue&type=style&index=0&id=b572ccd6&lang=less"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__